import axios from 'axios';
import config from '../../../config'

const API_ROOT = config.API_ROOT

export function editNotes(portal_user_id, id, user_id, mods) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
		const req = {
			id: id,
			user_id: user_id,
			mods: mods
		}
		axios.put(API_ROOT + `/portal/notes2/${portal_user_id}`, req, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
			.then((res) => {
			dispatch({ type: 'EDIT_NOTES_FULFILLED', payload: res.data });
			resolve(res)
		}).catch((err) => {
			dispatch({ type: 'EDIT_NOTES_REJECTED', payload: { response: err.response.data }})
			reject(err)
		})
		});
	}
}
  
export function deleteNote(portal_user_id, note_id) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
		axios.delete(API_ROOT + `/portal/notes/${portal_user_id}/${note_id}`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
			.then((res) => {
			dispatch({ type: 'DELETE_NOTES_FULFILLED', payload: res.data });
			resolve(res)
		}).catch((err) => {
			dispatch({ type: 'DELETE_NOTES_REJECTED', payload: { response: err.response.data }})
			reject(err)
		})
		});
	}
}

export function addNotes(portal_user_id, inspect_user_id, createdDate, created_by, note) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
		const req = {
			user_id: inspect_user_id,
			created_at: createdDate,
			created_by: created_by,
			note: note,
		}
		axios.post(API_ROOT + `/portal/notes/${portal_user_id}`, req, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
			.then((res) => {
				dispatch({ type: 'INSERT_NOTES_FULFILLED', payload: res.data });
				resolve(res);
			}).catch((err) => {
			dispatch({ type: 'INSERT_NOTES_REJECTED',
			payload: {
				message: 'Unable to submit note. Please try again'
			}
			})
			reject(err);
		})
		});
	}
}


export function showEditNoteModal(showModal, index) {
	return {
		type: 'SHOW_EDIT_NOTE_MODAL',
		payload: {
		showEditNoteModal: showModal,
		selectedNoteIndex: index,
		}
	}
}

export function showAddNoteModal(showModal) {
	return {
		type: 'SHOW_ADD_NOTE_MODAL',
		payload: {
		showAddNoteModal: showModal,
		}
	}
}

export function resetReduxState() {
	return {
		type: 'RESET_REDUX_STATE'
	}
}